import React from 'react';
import { motion } from 'framer-motion';
import { Sun, Cloud, Moon, MessageSquare, Smartphone } from 'lucide-react';
export function MechanismSection() {
  return <section className="w-full bg-[#FDF8F0] px-4 py-16 md:py-24" data-id="element-79">
      <div className="max-w-4xl mx-auto" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-81">
          <span className="text-[#C4704B] font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-82">
            El Método
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#1B2A4A] mb-4 font-serif" data-id="element-83">
            La solución: Swap 3×3
          </h2>
          <p className="text-xl text-[#4A5568]" data-id="element-84">Sustituye, no prohíbas.</p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-85">
          {/* Morning */}
          <motion.div whileHover={{
          y: -5
        }} className="bg-white p-6 rounded-xl shadow-lg border-t-4 border-[#C4704B]" data-id="element-86">
            <div className="bg-[#F5EDE3] w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-87">
              <Sun className="h-6 w-6 text-[#C4704B]" data-id="element-88" />
            </div>
            <h3 className="text-xl font-bold text-[#1B2A4A] mb-2" data-id="element-89">Mañana</h3>
            <p className="text-[#4A5568] text-sm" data-id="element-90">
              Momentos críticos antes de la escuela o al despertar.
            </p>
          </motion.div>

          {/* Afternoon */}
          <motion.div whileHover={{
          y: -5
        }} className="bg-white p-6 rounded-xl shadow-lg border-t-4 border-[#C4704B]" data-id="element-91">
            <div className="bg-[#F5EDE3] w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-92">
              <Cloud className="h-6 w-6 text-[#C4704B]" data-id="element-93" />
            </div>
            <h3 className="text-xl font-bold text-[#1B2A4A] mb-2" data-id="element-94">Tarde</h3>
            <p className="text-[#4A5568] text-sm" data-id="element-95">
              El regreso a casa y el aburrimiento.
            </p>
          </motion.div>

          {/* Night */}
          <motion.div whileHover={{
          y: -5
        }} className="bg-white p-6 rounded-xl shadow-lg border-t-4 border-[#C4704B]" data-id="element-96">
            <div className="bg-[#F5EDE3] w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-97">
              <Moon className="h-6 w-6 text-[#1B2A4A]" data-id="element-98" />
            </div>
            <h3 className="text-xl font-bold text-[#1B2A4A] mb-2" data-id="element-99">Noche</h3>
            <p className="text-[#4A5568] text-sm" data-id="element-100">
              La transición al sueño y la desconexión final.
            </p>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-101">
          <div className="bg-[#F5EDE3] p-6 rounded-xl flex items-start" data-id="element-102">
            <MessageSquare className="h-6 w-6 text-[#C4704B] mt-1 mr-4 flex-shrink-0" data-id="element-103" />
            <div data-id="element-104">
              <h4 className="font-bold text-[#1B2A4A] mb-1" data-id="element-105">Guiones cortos</h4>
              <p className="text-[#4A5568] text-sm" data-id="element-106">
                Para apagar sin debate y sin tener que pensar qué decir.
              </p>
            </div>
          </div>

          <div className="bg-[#F5EDE3] p-6 rounded-xl flex items-start" data-id="element-107">
            <Smartphone className="h-6 w-6 text-[#C4704B] mt-1 mr-4 flex-shrink-0" data-id="element-108" />
            <div data-id="element-109">
              <h4 className="font-bold text-[#1B2A4A] mb-1" data-id="element-110">
                Parking del celular
              </h4>
              <p className="text-[#4A5568] text-sm" data-id="element-111">
                Diseño del entorno para que no sea lo “más valioso” en la mano
                del adulto.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-112">
          <p className="text-lg font-medium text-[#1B2A4A] italic" data-id="element-113">
            "Esto no es teoría. Es un sistema de casa."
          </p>
        </div>
      </div>
    </section>;
}